// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigationPopupsContainer_dDEVk{
    position: sticky;
    top: 0px;
    width: 100%;
z-index: 1;
    @media (width<=768px) {
      max-width: 100%;
      min-width: 100%;
    }
    >div{
      height: 100vh;
      /* height: calc(100vh - 50px); */
      overflow-y: scroll;
      overflow-x: hidden;
      &::-webkit-scrollbar{
        display: none;
      }
      /* scrollbar-width: none;
  -ms-overflow-style: none;  
      &::-webkit-scrollbar {
        display: none; 
      } */
    }
  }

  .navigationPopupsContainerBill_gzGsl{
    max-width: 300px;
  }

  .navigationPopupsContainerContactAsset_eJ5mU{
    position: sticky;
    top: 0px;
    width: 100%;
    max-width: 240px;
    min-width: 230px;

    @media (width<=768px) {
      max-width: 100%;
      min-width: 100%;
    }
    >div{
      height: 100%;
      overflow-y: visible;
      /* scrollbar-width: none;
  -ms-overflow-style: none;  
      &::-webkit-scrollbar {
        display: none; 
      } */
    }
  }`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NavigationPopups/NavigationPopups.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,QAAQ;IACR,WAAW;AACf,UAAU;IACN;MACE,eAAe;MACf,eAAe;IACjB;IACA;MACE,aAAa;MACb,gCAAgC;MAChC,kBAAkB;MAClB,kBAAkB;MAClB;QACE,aAAa;MACf;MACA;;;;SAIG;IACL;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,gBAAgB;;IAEhB;MACE,eAAe;MACf,eAAe;IACjB;IACA;MACE,YAAY;MACZ,mBAAmB;MACnB;;;;SAIG;IACL;EACF","sourcesContent":[".navigationPopupsContainer{\n    position: sticky;\n    top: 0px;\n    width: 100%;\nz-index: 1;\n    @media (width<=768px) {\n      max-width: 100%;\n      min-width: 100%;\n    }\n    >div{\n      height: 100vh;\n      /* height: calc(100vh - 50px); */\n      overflow-y: scroll;\n      overflow-x: hidden;\n      &::-webkit-scrollbar{\n        display: none;\n      }\n      /* scrollbar-width: none;\n  -ms-overflow-style: none;  \n      &::-webkit-scrollbar {\n        display: none; \n      } */\n    }\n  }\n\n  .navigationPopupsContainerBill{\n    max-width: 300px;\n  }\n\n  .navigationPopupsContainerContactAsset{\n    position: sticky;\n    top: 0px;\n    width: 100%;\n    max-width: 240px;\n    min-width: 230px;\n\n    @media (width<=768px) {\n      max-width: 100%;\n      min-width: 100%;\n    }\n    >div{\n      height: 100%;\n      overflow-y: visible;\n      /* scrollbar-width: none;\n  -ms-overflow-style: none;  \n      &::-webkit-scrollbar {\n        display: none; \n      } */\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigationPopupsContainer": `navigationPopupsContainer_dDEVk`,
	"navigationPopupsContainerBill": `navigationPopupsContainerBill_gzGsl`,
	"navigationPopupsContainerContactAsset": `navigationPopupsContainerContactAsset_eJ5mU`
};
export default ___CSS_LOADER_EXPORT___;
